(ns teamoesterreich.admin-mode.data.text-block
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]

            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))


;(in-ns 'teamoesterreich.admin-mode.data.text-block)

(defn get-text-blocks [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/text-block")
                  (fn [r-list status]
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(get e "toeTextBlock-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                        )))))

(defn get-group-text-blocks [group-name done-fn]
  (when-not (or (= "" group-name) (nil? group-name))
    (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/text-block/groups/" group-name)
                    (fn [r-list status]
                      (when (= status 200)
                        (done-fn
                          (into {} (map (fn [e] [(get e "toeTextBlock-uuid") (clojure.walk/keywordize-keys e)]) (js->clj (json/parse r-list))))
                          ))))))






(defn get-text-groups [done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/text-block/groups")
                  (fn [r-list status]
                    (log/debug "get-text-blocks-groups done" r-list status)
                    (when (= status 200)
                      (done-fn
                        (into {} (map (fn [e] [(first e) (second e)]) (js->clj (json/parse r-list))))
                        )))))


(defn get-text-block [blockUuid done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/text-block/" blockUuid)
                  (fn [r-list status]
                    (log/debug "get-text-block done" r-list status)
                    (when (= status 200)
                      (done-fn
                        (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-list))))
                        )))))

(defn set-group [blockUuid group done-fn]
  (ajax/auth-patch> (backend/get-auth) (str backend/BASE_URL "/text-block/" blockUuid)
                    (ajax/serialize {:toeTextBlock-group group})
                    (fn [r-elm status]
                      ;(log/debug "set-text-block group done" r-elm status)
                      (when (< status 300)
                        (done-fn
                          (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elm))))
                          )))))

(defn set-text-block [blockUuid textBlock done-fn]
  (ajax/auth-patch> (backend/get-auth) (str backend/BASE_URL "/text-block/" blockUuid)
                    (ajax/serialize textBlock)
                    (fn [r-elm status]
                      (log/debug "set-text-block done" r-elm status)
                      (when (< status 300)
                        (done-fn
                          (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elm))))
                          )))))


(defn add-new [group name type done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/text-block")
                   (ajax/serialize {:toeTextBlock-group group
                                    :toeTextBlock-orgIdFilter  (first (d-rights/get-rights-orgId-filter d-rights/CLASSIC))
                                    :toeTextBlock-name  name
                                    :toeTextBlock-type  type})
                   (fn [r-elm status]
                     (log/debug "add-text-block done" r-elm status)
                     (when (< status 300)
                       (done-fn
                         (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elm))))
                         )))))



(defn copy-text-block [blockUuid orgMask done-fn]
  (ajax/auth-post> (backend/get-auth) (str backend/BASE_URL "/text-block/" blockUuid "/copy")
                   (ajax/serialize {:toeTextBlock-orgIdFilter orgMask})
                   (fn [r-elm status]
                     (log/debug "copy-text-block done" r-elm status)
                     (when (< status 300)
                       (done-fn
                         (into {} (clojure.walk/keywordize-keys (js->clj (json/parse r-elm))))
                         )))))


(defn drop-text-block [blockUuid done-fn]
  (ajax/auth-delete> (backend/get-auth) (str backend/BASE_URL "/text-block/" blockUuid)
                   (fn [r-elm status]
                     (log/debug "copy-text-block done" r-elm status)
                     (when (< status 300)
                       (done-fn)))))


